import { Helmet } from 'react-helmet-async'

export default function SeoHead({
  title = 'JARCon ApS',
  description = 'JARCon ApS og JARC Audio – Musik med nerve. Specialister i HiFi, lytterum og håndbyggede højtalere.',
  ogImage = 'https://assets.auxodev.dk/assets/d6e713fb-6411-4075-ab6a-5936b7a50d5a/scandinavian-hifi-listening-room.png',
  canonicalUrl
}) {
  const finalTitle = title.includes('JARCon') ? title : `${title} - JARCon ApS`

  return (
    <Helmet>
      <html lang="da" />
      <title>{finalTitle}</title>
      <meta name="description" content={description} />
      <meta property="og:title" content={finalTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      {ogImage && <meta property="og:image" content={ogImage} />}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={finalTitle} />
      <meta name="twitter:description" content={description} />
      {ogImage && <meta name="twitter:image" content={ogImage} />}
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
    </Helmet>
  )
}
